/**
 * Mapping of routes to components and teams for the CRM app
 * Sourcing and CP components at the top so they're matched first
 */
const teamComponentMapCrm = [
  // Sourcing components
  {
    pattern: "/cases/*/fact-find/*/protection",
    team: "sourcing",
    component: "case-fact-find-protection"
  },
  {
    pattern: "/cases/*/protection/*",
    team: "sourcing",
    component: "case-protection"
  },
  {
    pattern: "/cases/*/products",
    team: "sourcing",
    component: "case-products"
  },
  {
    pattern: "/cases/*/notes",
    team: "sourcing",
    component: "case-notes"
  },
  {
    pattern: "/cases/*/details/*",
    team: "sourcing",
    component: "case-requirements"
  },
  {
    pattern: "/reminders",
    team: "sourcing",
    component: "reminders"
  },
  {
    pattern: "/reports/*",
    team: "sourcing",
    component: "reports"
  },
  {
    pattern: "/user/*/settings/*",
    team: "sourcing",
    component: "user-settings"
  },
  {
    pattern: "/company/*/process/reminders",
    team: "sourcing",
    component: "company-process-reminders",
  },
  {
    pattern: "/company/*/process/calendar",
    team: "crm",
    component: "company-process-calendar",
  },

  // CP components
  {
    pattern: "/accounting/*",
    team: "cp",
    component: "accounting"
  },
  {
    pattern: "/go-cardless-callback",
    team: "cp",
    component: "auth-callback"
  },
  {
    pattern: "/cases/*/accounting",
    team: "cp",
    component: "case-accounting"
  },
  {
    pattern: "/company/*/introducers/*",
    team: "cp",
    component: "introducers"
  },
  {
    pattern: "/cases/*/survey",
    team: "cp",
    component: "case-survey"
  },
  {
    pattern: "/cases/*/fact-find/*/id-verification",
    team: "cp",
    component: "case-fact-find-id-verification"
  },

  // CRM components
  {
    pattern: "/",
    team: "crm",
    component: "root"
  },
  {
    pattern: "/login",
    team: "crm",
    component: "login"
  },
  {
    pattern: "/refresh",
    team: "crm",
    component: "login"
  },

  // Onboarding
  {
    pattern: "/welcome/*",
    team: "crm",
    component: "onboarding"
  },

  // Dashboard routes
  {
    pattern: "/dashboard/performance/company/*",
    team: "crm",
    component: "dashboard-performance-company",
  },
  {
    pattern: "/dashboard/performance/user/*",
    team: "crm",
    component: "dashboard-performance-user",
  },
  {
    pattern: "/dashboard/performance/network/*",
    team: "crm",
    component: "dashboard-performance-network",
  },
  {
    pattern: "/dashboard/compliance/company/*",
    team: "crm",
    component: "dashboard-compliance-company",
  },
  {
    pattern: "/dashboard/compliance/user/*",
    team: "crm",
    component: "dashboard-compliance-user",
  },
  {
    pattern: "/dashboard/compliance/network/*",
    team: "crm",
    component: "dashboard-compliance-network",
  },

  // Cases dashboard routes
  {
    pattern: "/cases/list-view",
    team: "crm",
    component: "cases-list"
  },
  {
    pattern: "/cases/list-view/*",
    team: "crm",
    component: "cases-list"
  },
  {
    pattern: "/cases/compliance-view",
    team: "crm",
    component: "case-compliance-list"
  },
  {
    pattern: "/cases/dashboard-list",
    team: "crm",
    component: "case-compliance-list"
  },
  {
    pattern: "/cases/board-view",
    team: "crm",
    component: "cases-board"
  },

  // Case routes
  {
    pattern: "/cases/new",
    team: "crm",
    component: "case-new"
  },
  {
    pattern: "/cases/*/overview",
    team: "crm",
    component: "case-overview"
  },
  // Fact Find
  {
    pattern: "/cases/*/fact-find/mortgage",
    team: "crm",
    component: "case-fact-find-mortgage"
  },
  {
    pattern: "/cases/*/fact-find/credit",
    team: "crm",
    component: "case-fact-find-credit"
  },
  {
    pattern: "/cases/:caseId/fact-find/employment",
    team: "crm",
    component: "case-fact-find-employment",
  },
  {
    pattern: "/cases/*/fact-find/properties",
    team: "crm",
    component: "case-fact-find-properties",
  },
  {
    pattern: "/cases/*/fact-find/properties/*",
    team: "crm",
    component: "case-fact-find-properties",
  },
  {
    pattern: "/cases/*/fact-find/*/personal-info",
    team: "crm",
    component: "case-fact-find-personal-info"
  },
  {
    pattern: "/cases/*/fact-find/*/income",
    team: "crm",
    component: "case-fact-find-income"
  },
  {
    pattern: "/cases/*/fact-find/*/retirement-income",
    team: "crm",
    component: "case-fact-find-retirement-income",
  },
  {
    pattern: "/cases/*/fact-find/*/outgoings",
    team: "crm",
    component: "case-fact-find-outgoings"
  },
  {
    pattern: "/cases/*/fact-find/*/conveyancing",
    team: "crm",
    component: "case-fact-find-conveyancing"
  },
  {
    pattern: "/cases/*/properties/*",
    team: "crm",
    component: "case-fact-find-properties"
  },
  {
    pattern: "/cases/*/fact-find/*",
    team: "crm",
    component: "case-fact-find"
  },
  {
    pattern: "/cases/*/home-insurance/*",
    team: "crm",
    component: "case-home-insurance"
  },
  {
    pattern: "/cases/*/home-insurance-products/*",
    team: "crm",
    component: "case-home-insurance-products"
  },
  {
    pattern: "/cases/*/health/*",
    team: "crm",
    component: "case-health"
  },
  {
    pattern: "/cases/*/documents",
    team: "crm",
    component: "case-documents"
  },
  {
    pattern: "/cases/*/contacts",
    team: "crm",
    component: "case-contacts"
  },
  {
    pattern: "/cases/*/suitability/*",
    team: "crm",
    component: "case-suitability"
  },
  {
    pattern: "/cases/*/wills",
    team: "crm",
    component: "case-wills"
  },
  {
    pattern: "/cases/*/review-mode/*",
    team: "crm",
    component: "case-review-mode"
  },

  // Compliance
  {
    pattern: "/compliance/cases/*",
    team: "crm",
    component: "case-compliance"
  },

  // Clients
  {
    pattern: "/clients",
    team: "crm",
    component: "clients-list"
  },
  {
    pattern: "/clients/*/overview",
    team: "crm",
    component: "client-overview"
  },
  {
    pattern: "/clients/*/profile/*",
    team: "crm",
    component: "client-profile"
  },
  {
    pattern: "/clients/*/properties/new",
    team: "crm",
    component: "client-profile-new-property",
  },
  {
    pattern: "/clients/*/properties/edit/*",
    team: "crm",
    component: "client-profile-edit-property",
  },
  {
    pattern: "/clients/*/properties/*/property-info/*",
    team: "crm",
    component: "client-profile-property-info",
  },
  {
    pattern: "/clients/*/health/*",
    team: "crm",
    component: "client-health"
  },
  {
    pattern: "/clients/*/cases",
    team: "crm",
    component: "client-cases"
  },
  {
    pattern: "/clients/*/documents",
    team: "crm",
    component: "client-documents"
  },
  {
    pattern: "/clients/*/protection",
    team: "crm",
    component: "client-protection"
  },
  {
    pattern: "/clients/*/communication",
    team: "crm",
    component: "client-communication"
  },
  {
    pattern: "/clients/*/settings",
    team: "crm",
    component: "client-settings"
  },

  // Company routes
  {
    pattern: "/company/*/information",
    team: "crm",
    component: "company-information"
  },
  {
    pattern: "/company/*/appointed-representatives",
    team: "crm",
    component: "company-firm-list"
  },
  {
    pattern: "/company/*/mortgage-fees",
    team: "crm",
    component: "company-mortgage-fees"
  },
  {
    pattern: "/company/*/users",
    team: "crm",
    component: "company-users"
  },
  {
    pattern: "/company/*/users/*/feature-flags",
    team: "crm",
    component: "company-feature-flags",
  },
  {
    pattern: "/company/*/users/*/*",
    team: "crm",
    component: "company-user-details"
  },
  {
    pattern: "/company/*/panels/*",
    team: "crm",
    component: "company-panel-management"
  },
  {
    pattern: "/company/*/mortgage-panel",
    team: "crm",
    component: "company-mortgage-panel"
  },
  {
    pattern: "/company/*/gi-panel",
    team: "crm",
    component: "company-panels"
  },
  {
    pattern: "/company/*/templates",
    team: "crm",
    component: "company-templates"
  },
  {
    pattern: "/company/*/integrations",
    team: "crm",
    component: "company-integrations"
  },
  {
    pattern: "/company/*/regulatory",
    team: "crm",
    component: "company-regulatory-information"
  },
  {
    pattern: "/company/*/document-requirements",
    team: "crm",
    component: "company-document-requirements"
  },
  {
    pattern: "/company/*/payments",
    team: "crm",
    component: "company-payments"
  },
  {
    pattern: "/company/*/commercial-details",
    team: "crm",
    component: "company-commercial-details"
  },
  {
    pattern: "/company/*/user-groups",
    team: "crm",
    component: "company-user-groups"
  },
  {
    pattern: "/company/*/firms",
    team: "crm",
    component: "company-firm-list"
  },
  {
    pattern: "/company/*/feature-flags",
    team: "crm",
    component: "company-feature-flags"
  },
  {
    pattern: "/company/*/credit-support-tools",
    team: "crm",
    component: "company-credit-support-tools"
  },
  {
    pattern: "/company/*/calendar-structures",
    team: "crm",
    component: "company-calendar-structures"
  },

  {
    pattern: "/documents/*",
    team: "crm",
    component: "documents"
  },
]

export default teamComponentMapCrm
